import React, { createRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FixedCropper, ImageRestriction } from "react-advanced-cropper";
import { getZoomFactor } from "advanced-cropper/extensions/absolute-zoom";
import { uploadPhotoRequirements } from "../models";
import "react-advanced-cropper/dist/style.css";

const RANGE_MIN = 0;
const RANGE_MAX = 1;
const RANGE_STEP = 0.02;

const UploadPhotoModal = ({
    $locale, isModalOpen, onChange, onClose,
}) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [zoomValue, setZoomValue] = useState(RANGE_MIN);

    const cropperRef = createRef();
    const rangeRef = createRef();

    const handleChangePage = () => {
        onClose();
        setUploadedFile(null);
        setImageSrc(null);
    };

    const handleUploadFile = (file) => {
        setUploadedFile(file);
        setImageSrc(URL.createObjectURL(file));
    };

    const handleSavePhoto = async () => {
        const cropper = cropperRef.current;

        if (!cropper) return;

        const dataURL = cropper.getCanvas().toDataURL();
        const response = await fetch(dataURL);
        const blob = await response.blob();
        const file = new File(
            [blob],
            "fileName.jpg",
            {
              type: "image/jpeg",
              lastModified: new Date(),
            }
        );

        onChange(file);
        onClose();
    }

    const handleChangeRange = (value) => {
        const cropper = cropperRef.current;

        if (!cropper) return;

        const state = cropper.getState();
        const settings = cropper.getSettings();

        cropper.zoomImage(getZoomFactor(state, settings, value), {});

        setZoomValue(value);

        const progress = Math.round((value / RANGE_MAX) * 100);
        rangeRef.current.style.background = `linear-gradient(to right, #FF121D ${progress}%, var(--app-color-2) ${progress}%)`;
    };

    return (
        <Modal
            show={isModalOpen}
            className="upload-photo-modal"
        >
            <Modal.Header>
                <button onClick={handleChangePage}>{$locale.get('registration.addPhoto.back')}</button>
            </Modal.Header>
            <Modal.Body>
                {!uploadedFile
                    ? <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <img
                            src="/player/images/example-photo.jpg"
                            alt={$locale.get('registration.addPhoto.examplePhoto')}
                        />
                        <p style={{marginTop: '20px'}}>{$locale.get('registration.addPhoto.examplePhoto')}</p>
                        <ul>
                            {Object.entries(uploadPhotoRequirements).map(([key, value]) => (
                                <li key={key}>
                                    {$locale.get(`${value}`)};
                                </li>
                            ))}
                        </ul> 
                    </div>
                    : <div style={{maxWidth: '400px'}}>
                        <FixedCropper
                            ref={cropperRef}
                            src={imageSrc}
                            stencilSize={{
                                width: 300,
                                height: 400,
                            }}
                            stencilProps={{
                                movable: false,
                                resizable: false,
                                handlers: {},
                                lines: {},
                            }}
                            imageRestriction={ImageRestriction.stencil}
                            backgroundWrapperProps={{
                                scaleImage: false,
                            }}
                        />
                        <div style={{marginTop: '20px', display: 'grid', gridTemplateColumns: '24px 1fr 24px', alignItems: 'center'}}>
                            <span onClick={() => handleChangeRange(+zoomValue - RANGE_STEP)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{display: 'block'}}>
                                    <rect x="4" y="10" width="16" height="4" rx="2" fill="#FF121D"/>
                                </svg>
                            </span>
                            <input
                                ref={rangeRef}
                                type="range"
                                value={zoomValue}
                                step={RANGE_STEP}
                                min={RANGE_MIN}
                                max={RANGE_MAX}
                                className="range"
                                onChange={(e) => handleChangeRange(e.target.value)}
                            />
                            <span onClick={() => handleChangeRange(+zoomValue + RANGE_STEP)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{display: 'block'}}>
                                    <rect x="4" y="10" width="16" height="4" rx="2" fill="#FF121D"/>
                                    <rect x="10" y="20" width="16" height="4" rx="2" transform="rotate(-90 10 20)" fill="#FF121D"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer style={{display: 'flex', justifyContent: 'center', gap: '12px'}}>
                <Button style={{position: 'relative', width: 'max-content'}}>
                    {!uploadedFile ? 'Загрузить' : 'Добавить другую'}
                    <input
                        type="file"
                        style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0}}
                        onChange={(e) => handleUploadFile(e.target.files[0])}
                    />
                </Button>
                {uploadedFile && (
                    <Button onClick={handleSavePhoto}>{$locale.get('registration.addPhoto.save')}</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default UploadPhotoModal;
